export default "__VITE_ASSET__9226d519__"